import React, { cloneElement, Fragment } from "react";
import { useHistory } from "react-router-dom";

const Jumper = ( props ) => {

  const history = useHistory();

  return cloneElement( props.children || <Fragment />, {
    onHide : history.goBack
  } );

};

export default Jumper;
